import React from "react";

import { Allergies } from "./Allergies/Allergies.jsx";
import s from "./AllergiesIntolerance.module.css";
import { Intolerances as Intolerance } from "./Intolerance/Intolerance.jsx";

const AlergiesIntolerance = () => {
  return (
    <div className={s.cardWrapper}>
      <Allergies />
      <Intolerance />
    </div>
  );
};

export { AlergiesIntolerance };